<template>
  <van-popup v-model:show="innerShow" position="bottom" round class="conflict-popup">
    <div class="conflict-header">
      <van-icon name="warning-o" color="#ee0a24" size="16" />
      <span class="conflict-msg">{{ message }}</span>
    </div>
    <div class="conflict-body">
      <van-cell-group v-for="(item, idx) in data" :key="idx" class="conflict-item">
        <van-cell :title="item.courseName || '课程'">
          <template #right-icon>
            <van-tag :type="item.status === 2 ? 'success' : 'info'" plain size="small" style="margin-top: 2px;">
              {{ item.status === 2 ? '已考勤' : '未考勤' }}
            </van-tag>
          </template>
          <template #label>
            <div class="conflict-line">{{ item.schoolName }} · {{ formatDateTime(item.startTime) }} ~ {{ formatTime(item.endTime) }}</div>
            <div class="conflict-line">授课教师：{{ item.teacherName }}</div>
            <div v-if="item.studentNames" class="conflict-line">已排学生：{{ item.studentNames }}</div>
          </template>
        </van-cell>
      </van-cell-group>
    </div>
    <div class="conflict-footer">
      <van-button round block type="primary" @click="innerShow = false">我知道了</van-button>
    </div>
  </van-popup>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  show: { type: Boolean, default: false },
  message: { type: String, default: '存在排课时间冲突，冲突详情如下：' },
  data: { type: Array, default: () => [] }
})

const emit = defineEmits(['update:show'])

const innerShow = computed({
  get: () => props.show,
  set: val => emit('update:show', val)
})

const pad = n => String(n).padStart(2, '0')

const formatDateTime = str => {
  if (!str) return ''
  const d = new Date(str)
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
}

const formatTime = str => {
  if (!str) return ''
  const d = new Date(str)
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`
}
</script>

<style scoped>
.conflict-popup {
  background-color: #fff;
  overflow: hidden;
}
.conflict-header {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 16px 16px 12px;
  color: #ee0a24;
  font-size: 14px;
  font-weight: 500;
}
.conflict-msg {
  flex: 1;
  word-break: break-all;
}
.conflict-body {
  max-height: 55vh;
  overflow-y: auto;
  padding: 0 8px;
}
.conflict-item {
  margin-bottom: 8px;
  border: 1px solid #ebedf0;
  border-radius: 8px;
  overflow: hidden;
}
.conflict-line {
  margin-top: 2px;
  color: #666;
  font-size: 12px;
  line-height: 1.5;
}
.conflict-footer {
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  border-top: 1px solid #ebedf0;
}
</style>
